/* eslint-disable no-bitwise */
import React from 'react';

const hexToRgb = (hex: string) => {
  const bigint = parseInt(hex.slice(1), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

const rgbToHex = (r: number, g: number, b: number) => {
  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
};

const interpolateColor = (color1: string, color2: string, factor: number) => {
  const [r1, g1, b1] = hexToRgb(color1);
  const [r2, g2, b2] = hexToRgb(color2);
  const r = Math.round(r1 + factor * (r2 - r1));
  const g = Math.round(g1 + factor * (g2 - g1));
  const b = Math.round(b1 + factor * (b2 - b1));
  return rgbToHex(r, g, b);
};

const getColor = (index: number, totalBars: number) =>
  interpolateColor('#DF1B7D', '#FF4757', index / (totalBars - 1));

const LoaderComponent = () => {
  const bars = [
    { animation: 'loader-bar-1', duration: '0.2s', marginTop: '0rem' },
    { animation: 'loader-bar-2', duration: '0.3s', marginTop: '0rem' },
    { animation: 'loader-bar-3', duration: '0.5s', marginTop: '1.563rem' },
    { animation: 'loader-bar-4', duration: '0.4s', marginTop: '0rem' },
    { animation: 'loader-bar-5', duration: '0.25s', marginTop: '0rem' },
  ];

  return (
    <div className="flex h-full justify-center items-center w-full">
      <div
        id="screenapp-loader"
        className="flex justify-center items-center h-[3.125rem] gap-[0.469rem]"
        data-testid="loader-component"
      >
        {bars.map((bar, index) => (
          <div
            key={index}
            className="w-[1.0225rem] rounded-[20px] relative box-border"
            style={{
              animation: `${bar.animation} ${bar.duration} linear infinite alternate`,
              marginTop: bar.marginTop,
              background: getColor(index, bars.length),
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoaderComponent;
